export default "__VITE_ASSET__BWLVGvir__"